
import { Component, Vue } from 'vue-property-decorator'
@Component
export default class ChangeStore extends Vue {
    /**
   * 切换店铺
   */
  changeStore () {
    this.$router.push('/selectStore')
  }
}
